import React from 'react';
import { Navigate } from 'react-router-dom';
import jwtUtils from '../utilities/jwtUtils';

const ProtectedRouteOperaciones = ({ element }) => {
  const payload = jwtUtils.getValidRefreshTokenPayload();
  if (!payload) {
    return <Navigate to="/401" replace />;
  }

  if (payload.rol !== 'operaciones') {
    return <Navigate to="/401" replace />;
  }

  return element;
};

export default ProtectedRouteOperaciones;
